import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
const samplePurchases = [{
  name: 'Michael R.',
  location: 'Austin, Texas'
}, {
  name: 'David L.',
  location: 'Phoenix, Arizona'
}, {
  name: 'James T.',
  location: 'Tampa, Florida'
}, {
  name: 'Robert K.',
  location: 'Denver, Colorado'
}, {
  name: 'Carlos M.',
  location: 'San Diego, California'
}, {
  name: 'Brandon S.',
  location: 'Charlotte, North Carolina'
}, {
  name: 'Kevin P.',
  location: 'Columbus, Ohio'
}, {
  name: 'Anthony G.',
  location: 'Las Vegas, Nevada'
}];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(samplePurchases[0]);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(samplePurchases[Math.floor(Math.random() * samplePurchases.length)]);
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);
  if (!visible) return null;
  return <aside className="fixed bottom-3 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[260px] animate-slide-in" aria-live="polite" data-id="element-130" data-mp="n7wijafaekfk">
      <div className="relative overflow-hidden rounded-xl border-2 border-brand-orange bg-white p-3 pr-8 shadow-2xl ring-2 ring-brand-amber/70" data-id="element-131" data-mp="iaeloiejnvnx">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-amber" data-id="element-132" data-mp="s56hphshaagl" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1.5 top-1.5 rounded p-0.5 text-brand-muted transition-colors hover:text-brand-ink" aria-label="Close purchase notification" data-id="element-133" data-mp="28k7pypgyg8hv">
          <XIcon className="h-3.5 w-3.5" data-id="element-134" data-mp="2aobbih2afotc" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-135" data-mp="2fmuzso4ctcov">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-orange/60 bg-brand-amber/20" data-id="element-136" data-mp="2fph8ws6w8097">
            <ShoppingBagIcon className="h-4 w-4 text-brand-orange" data-id="element-137" data-mp="2pm3ujj71mvca" />
          </div>
          <div className="min-w-0 leading-tight" data-id="element-138" data-mp="1rybqq6dhcvvq">
            <p className="font-display text-sm font-extrabold text-brand-ink" data-id="element-139" data-mp="1rzwos5z06wyc">{current.name}</p>
            <p className="text-[11px] font-semibold text-brand-muted" data-id="element-140" data-mp="1wxoj16n4ev5p">from {current.location}</p>
            <p className="mt-0.5 text-xs font-bold text-brand-orange" data-id="element-141" data-mp="21uoopgg25vwa">
              just purchased {PRODUCT_NAME}
            </p>
          </div>
        </div>
      </div>
    </aside>;
}